import { render, staticRenderFns } from "./busesRoute.vue?vue&type=template&id=71c3f88a&scoped=true&"
import script from "./busesRoute.vue?vue&type=script&lang=js&"
export * from "./busesRoute.vue?vue&type=script&lang=js&"
import style0 from "./busesRoute.vue?vue&type=style&index=0&id=71c3f88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3f88a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCheckbox,VDataTable,VForm,VIcon,VTabItem,VTabsItems})
